import React from 'react';
import PropTypes from 'prop-types';
import GenderWrapper from './Gender.style';

class Gender extends React.Component {
  render() {
    const { showError, gender, onChange } = this.props;
    return (
      <GenderWrapper>
        <div style={{marginTop: 16}} className='Gender' >
          <span className={showError && !gender ? 
            'Gender-title Gender-error' : 
            'Gender-title'}
          >
            Selecciona tu sexo
          </span>
          <div className="Gender-buttons">
            <button className="" onClick={() => onChange('gender', 'M')}>
              <div className={`Gender-button ${gender === 'M' ? 'Gender-button--on' : 'Gender-button--off' }`}>Masculino</div>
            </button>
            <button className="" onClick={() => onChange('gender', 'F')}>
              <div className={`Gender-button ${gender === 'F' ? 'Gender-button--on' : 'Gender-button--off' }`}>Femenino</div>
            </button>
          </div>
        </div>
      </GenderWrapper>
    );
  }
};

Gender.propTypes = {
  showError: PropTypes.bool,
  gender: PropTypes.string,
  onChange: PropTypes.func,
}

export default Gender;


